import AppLauncher from './components/app-launcher/AppLauncher'
import {useParams} from 'react-router-dom'
import {useEffect} from 'react'
import useCurrentApp from './hooks/useCurrentApp'
import {setFavoriteApp} from './store/appsSlice'
import {useDispatch} from 'react-redux'
import useFavoriteApps from './hooks/useFavoriteApps'

export const FavoriteApp = () => {
  const dispatch = useDispatch()
  const {favorite} = useParams()
  const [favorites] = useFavoriteApps()
  const [, setCurrentApp] = useCurrentApp()

  useEffect(() => {
    const favoriteToLoad = favorites.find((f) => f.id === favorite)
    if (!favoriteToLoad) {
      return
    }
    dispatch(setFavoriteApp(favoriteToLoad))
    setCurrentApp(favoriteToLoad.app, favoriteToLoad.parameters)
  }, [favorite, favorites])

  return <AppLauncher key={favorite} />
}
